import NiceSelect from '../helpers/nice-select2'
import refs from '../helpers/refs'
import site from '../helpers/site'
import priceHelper from '../helpers/price'

class CProductFauxVariant {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)
    this.site = site()

    // format prices before running NiceSelect
    const fauxVariantOptions = this.$root.querySelectorAll('option')
    fauxVariantOptions.forEach((option) => {
      const optionPrice = option.dataset.variantShopifyPrice
      const newPrice = priceHelper.formatPrice(optionPrice)
      const optionParts = option.innerText.split(' -')
      // remove last bit of the option text, which should be the price
      optionParts.pop()
      let finalOption = ''
      // rebuild the option text with all except last part
      optionParts.forEach((part) => {
        finalOption += ' ' + part.trim()
      })
      // add the formatted price back into the option text
      finalOption += ' - ' + newPrice
      // update the text of the element
      option.innerText = finalOption
    })

    if (document.getElementById('fauxSize')) {
      this.sizeSelect = new NiceSelect(document.getElementById('fauxSize'), { })
    }
    if (document.getElementById('fauxSeries')) {
      this.sizeSelect = new NiceSelect(document.getElementById('fauxSeries'), { })
    }
    if (document.getElementById('fauxVariant')) {
      this.variantSelect = new NiceSelect(document.getElementById('fauxVariant'), { })
    }

    this.init()
  }

  init () {
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.m-product-faux-variant')
    .forEach(el => new CProductFauxVariant(el))
})
